export const DEGREE_TITLES = {
    CERTIFICATE: 'Certificate',
    BA: 'B.A.',
    BARCH: 'BArch',
    BFA: 'BFA',
    BSC: 'B.Sc.',
    MA: 'M.A.',
    MBA: 'M.B.A.',
    MFA: 'MFA',
    MSC: 'M.Sc.',
    JD: 'J.D.',
    MD: 'M.D.',
    PHD: 'Ph.D',
    LLB: 'LLB',
    LLM: 'LLM',
    ASSOCIATE: 'Associate',
    BM: 'BM',
    OTHER: 'Other',
};
